import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TimeFormatService {

  constructor() { }

  
  /**
   * Convert seconds to HH:mm:ss string
   * @param totalSeconds number
   * @returns formatted time string
   */
  formatSecondsToHHMMSS(totalSeconds: number): string {
    const sec = Math.floor(totalSeconds);
    const h = String(Math.floor(sec / 3600)).padStart(2, '0');
    const m = String(Math.floor((sec % 3600) / 60)).padStart(2, '0');
    const s = String(sec % 60).padStart(2, '0');
    return `${h}:${m}:${s}`;
  }

  /**
   * Convert video element currentTime to HH:mm:ss
   * @param video HTMLVideoElement
   */
  getVideoCurrentTime(video: HTMLVideoElement): string {
    return this.formatSecondsToHHMMSS(video.currentTime);
  }

  

  /**
 * Convert time string (HH:mm:ss) into seconds
 * @param timeString format "HH:mm:ss" or "mm:ss"
 */
  convertToSecondsFormat(timeString: string): number {
    if (!timeString) return 0;
    const parts = timeString.split(':').map(Number);
    if (parts.length === 3) {
      const [hours, minutes, seconds] = parts;
      return (hours * 3600) + (minutes * 60) + seconds;
    }
    if (parts.length === 2) {
      const [minutes, seconds] = parts;
      return (minutes * 60) + seconds;
    }
    return 0; // fallback if format is invalid
  }
  
}
